import PropTypes from 'prop-types';
import React from 'react';

import TranslationUtils from 'Utils/TranslationUtils';

import styles from './BlockPageForPublicDomains.module.less';
import PiplLogo from '../../../Assets/pipl.svg';
import { trackEvent } from '../../LeadVettingPage/utils';

const BlockPageForPublicDomains = ({ history }) => {
  const goBack = (e) => {
    e.preventDefault();
    trackEvent('public_email_back', '');
    history.goBack(e);
  };

  return (
    <div className={styles.container}>
      <a href="https://pipl.com">
        <img src={PiplLogo} alt="" width="120" height="75" />
      </a>
      <div className={styles.content}>
        <div test-id="page-title">{TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_INTRO')}</div>
        <br />
        <div>
          {`${TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_PREFIX')} `}
          <a href="#" onClick={goBack} className={styles.footerLink}>
            {TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_LINK_TEXT')}
          </a>
          {` ${TranslationUtils.getText('BLOCK_PAGE_FOR_PUBLIC_DOMAINS_TITLE_SUFFIX')}`}
        </div>
      </div>
      <div className={styles.footer}>
        <span>{TranslationUtils.getText('BLOCK_PAGE_SUBTITLE')}</span>
        <a href="mailto:support@pipl.com" className={styles.footerLink}>
          <span>{TranslationUtils.getText('BLOCK_PAGE_LINK')}</span>
        </a>
      </div>
    </div>
  );
};

BlockPageForPublicDomains.propTypes = {
  history: PropTypes.object,
};

export default BlockPageForPublicDomains;
